import { gql } from "@apollo/client";

const MEMBER_FIELDS = `
  id
  email
  firstName
  lastName
  avatarUrl
  role
  isOwner
  permissions
  createdAt
`;

export const GET_WORKSPACE_MEMBERS = gql`
  query GetMarketingWorkspaceMembers($workspaceId: String!, $pageSize: Int, $pageNumber: Int) {
    marketingWorkspaceMembers(workspaceId: $workspaceId, pageSize: $pageSize, pageNumber: $pageNumber) {
      items {
        ${MEMBER_FIELDS}
      }
      count
      hasNextPage
    }
  }
`;

export const SEARCH_WORKSPACE_MEMBER_CANDIDATES = gql`
  query SearchMarketingWorkspaceMemberCandidates(
    $workspaceId: String!
    $email: String!
    $limit: Int = 10
  ) {
    searchMarketingWorkspaceMemberCandidates(
      workspaceId: $workspaceId
      email: $email
      limit: $limit
    ) {
      id
      email
      firstName
      lastName
      isMember
    }
  }
`;

export const GET_GRANTABLE_WORKSPACE_PERMISSIONS = gql`
  query GetGrantableMarketingWorkspacePermissions {
    grantableMarketingWorkspacePermissions
  }
`;

export const UPSERT_WORKSPACE_MEMBER = gql`
  mutation UpsertMarketingWorkspaceMember(
    $workspaceId: String!
    $request: UpsertMarketingWorkspaceMemberInput!
  ) {
    upsertMarketingWorkspaceMember(workspaceId: $workspaceId, request: $request) {
      id
      email
      firstName
      lastName
      avatarUrl
      role
      isOwner
      permissions
      createdAt
    }
  }
`;

export const REMOVE_WORKSPACE_MEMBER = gql`
  mutation RemoveMarketingWorkspaceMember($workspaceId: String!, $userExternalId: String!) {
    removeMarketingWorkspaceMember(workspaceId: $workspaceId, userExternalId: $userExternalId)
  }
`;

const INVITATION_FIELDS = `
  id
  email
  role
  status
  permissions
  workspaceId
  workspaceName
  createdAt
  expiresAt
`;

export const GET_WORKSPACE_PENDING_INVITATIONS = gql`
  query GetMarketingWorkspacePendingInvitations($workspaceId: String!, $pageSize: Int, $pageNumber: Int) {
    marketingWorkspacePendingInvitations(workspaceId: $workspaceId, pageSize: $pageSize, pageNumber: $pageNumber) {
      items {
        ${INVITATION_FIELDS}
      }
      count
      hasNextPage
    }
  }
`;

export const GET_MY_PENDING_INVITATIONS = gql`
  query GetMyMarketingWorkspaceInvitations {
    myMarketingWorkspaceInvitations {
      ${INVITATION_FIELDS}
    }
  }
`;

export const INVITE_WORKSPACE_MEMBER = gql`
  mutation InviteMarketingWorkspaceMember(
    $workspaceId: String!
    $request: InviteMarketingWorkspaceMemberInput!
  ) {
    inviteMarketingWorkspaceMember(workspaceId: $workspaceId, request: $request) {
      ${INVITATION_FIELDS}
    }
  }
`;

export const ACCEPT_WORKSPACE_INVITATION = gql`
  mutation AcceptMarketingWorkspaceInvitation($token: String!) {
    acceptMarketingWorkspaceInvitation(token: $token) {
      ${MEMBER_FIELDS}
    }
  }
`;

export const ACCEPT_WORKSPACE_INVITATION_BY_ID = gql`
  mutation AcceptMarketingWorkspaceInvitationById($invitationId: String!) {
    acceptMarketingWorkspaceInvitationById(invitationId: $invitationId) {
      ${MEMBER_FIELDS}
    }
  }
`;

export const REVOKE_WORKSPACE_INVITATION = gql`
  mutation RevokeMarketingWorkspaceInvitation($workspaceId: String!, $invitationId: String!) {
    revokeMarketingWorkspaceInvitation(workspaceId: $workspaceId, invitationId: $invitationId)
  }
`;

export const RESEND_WORKSPACE_INVITATION = gql`
  mutation ResendMarketingWorkspaceInvitation($workspaceId: String!, $invitationId: String!) {
    resendMarketingWorkspaceInvitation(workspaceId: $workspaceId, invitationId: $invitationId) {
      ${INVITATION_FIELDS}
    }
  }
`;
